import clsx from 'clsx';
import React, { ReactNode } from 'react';

interface CommonProps {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
}

interface ItemProps {
  onClick?: () => void;
}

const Container = ({ children, className }: CommonProps) => {
  return (
    <div
      className={clsx(
        'rounded-medium bg-dark shadow-default divide-y divide-white20',
        className
      )}
    >
      {children}
    </div>
  );
};

const Item = ({
  children,
  className,
  onClick,
  disabled,
}: CommonProps & ItemProps) => {
  return (
    <div>
      <button
        className={clsx(
          'border-none text-left w-full p-2 text-white font-medium text-body',
          { 'cursor-default opacity-40': disabled },
          className
        )}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    </div>
  );
};

const MobileMenu = {
  Container,
  Item,
};

export default MobileMenu;
